import styled from "styled-components";

export const HeaderButtonsContainer = styled.div`
    height: 100%;

    display: flex;
    justify-content: flex-start;
    align-items: center;
`;
